export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const API_URL = process.env.REACT_APP_DEFAULT_API_URL;
export const MOCK_API = process.env.REACT_APP_MOCK_API === 'true';
export const VERSION = 'PROJECT-VERSION';
